module.exports = __webpack_public_path__ + "img/pasture_buffel_low.4a9a96ee.jpg";